import type { CurrentUser } from '../types'
import { useLang } from '../lang'
import { StationPageTab } from './StationPageTab'

function csrf(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

// The public description of the daily letter — the page a stranger lands on from a link, and
// the one an outside reviewer reads to see what subscribing actually gets them. Deliberately
// NOT behind require_login: /account redirects a signed-out visitor to the root, so without
// this page there is no address to give anybody asking "where do people sign up?".
//
// The prose is the station's (content/letter.<lang>.md); this adds the two things markdown
// can't carry — a real sample of what arrives, and the way in. Signed out that is Google
// sign-in (the same POST the masthead makes, since OmniAuth needs a CSRF-protected form);
// signed in it is the account page, where the opt-in itself lives. We never subscribe anybody
// from here: the second, separate step is the whole point of the arrangement.
export function LetterTab({ user }: { user: CurrentUser | null }) {
  const { t } = useLang()

  return (
    <StationPageTab slug="letter">
      <div className="ed-page-cta">
        <a className="ed-page-sample" href="/journal">
          {t('Read yesterday’s letter on the site', 'Léigh litir an lae inné ar an suíomh')}
        </a>

        {user ? (
          <a className="ed-page-btn" href="/account">
            {t('Turn the letter on in your account', 'Cuir an litir ar siúl i do chuntas')}
          </a>
        ) : (
          <form method="post" action="/auth/google_oauth2">
            <input type="hidden" name="authenticity_token" value={csrf()} />
            <button className="ed-page-btn" type="submit">
              <i className="ti ti-login-2" aria-hidden="true" />{' '}
              {t('Sign in with Google to subscribe', 'Sínigh isteach le Google chun liostáil')}
            </button>
          </form>
        )}

        <p className="ed-page-fine">
          {t(
            'Signing in does not subscribe you. You turn the letter on yourself, afterwards, on your account page — and one click in any letter turns it off again for good.',
            'Ní chuireann síniú isteach ar liosta thú. Cuireann tú féin an litir ar siúl ina dhiaidh sin, ar leathanach do chuntais — agus cuireann cliceáil amháin in aon litir as í arís go deo.',
          )}
        </p>
      </div>
    </StationPageTab>
  )
}
